function MoveElementOnScroll(element, _ref) {
  var container = _ref.container,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? element.offsetHeight : _ref$max,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 1 : _ref$speed,
      _ref$smooth = _ref.smooth,
      smooth = _ref$smooth === void 0 ? 2 : _ref$smooth,
      _ref$onUpdate = _ref.onUpdate,
      onUpdate = _ref$onUpdate === void 0 ? function () {
    return null;
  } : _ref$onUpdate,
      _ref$onEndScroll = _ref.onEndScroll,
      onEndScroll = _ref$onEndScroll === void 0 ? function () {
    return null;
  } : _ref$onEndScroll;
  var moving = false;
  var pos = min;
  var lastPos = pos; // todo: move this to utils if we finally need it

  var requestFrame = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (func) {
      window.setTimeout(func, 1000 / 50);
    };
  }();

  function update() {
    moving = true;
    var delta = (pos - lastPos) / smooth;
    lastPos += delta;

    if (Math.abs(delta) > 0.7) {
      requestFrame(function () {
        onUpdate(lastPos, delta);
        update();
      });
    } else {
      onEndScroll(pos);
      moving = false;
    }
  }

  function scrolling(e) {
    e.preventDefault(); // disable default scrolling

    var delta = e.delta || e.wheelDelta;

    if (delta === undefined) {
      // for firefox
      delta = -e.detail;
      delta *= 10 * speed;
    }

    pos += -delta * speed;
    pos = Math.max(min, Math.min(pos, max)); // limit scrolling

    if (!moving) {
      update();
    }
  }

  container.addEventListener('mousewheel', scrolling, false);
  container.addEventListener('DOMMouseScroll', scrolling, false);
  return {
    unsubscribe: function unsubscribe() {
      container.removeEventListener('mousewheel', scrolling);
      container.removeEventListener('DOMMouseScroll', scrolling);
    },
    updatePosition: function updatePosition(newPos) {
      pos = -newPos;
      lastPos = -pos;
    }
  };
}

export default MoveElementOnScroll;
export { MoveElementOnScroll };
//# sourceMappingURL=moveElementOnScroll.js.map
